// @ts-nocheck
/* Libraries */
import React, { memo } from 'react';
import cn from 'classnames';
import dynamic from 'next/dynamic';
// @ts-ignore
import { SearchProvider, SearchBox, WithSearch } from '@elastic/react-search-ui';
// @ts-ignore
import { Layout } from '@elastic/react-search-ui-views';
/* Components */
import { InputField } from 'ht-styleguide';
/* Helpers */
import { SegmentTrackingAction, TRACKING_TYPES } from '@integrations/segment/search';
import { getScoredResults } from './helpers';
import { searchConfig, DEFAULT_TEXTS } from './constants';

/* Styles */
import styles from './searchbar.module.scss';

/* Dynamic Components */
const HeroPageResults = dynamic(() => import('@components/Searchbar/Hero/Hero.Results'));
const Results = dynamic(() => import('@components/PageLayouts/Header/Standard/Parts/SearchBar/Results'));

/* Types */
type SearchInputProps = {
  iconClick?: BaseAnyFunction;
  isHeroSearch?: boolean;
  autoFocus?: boolean;
  inputClass?: string;
  iconName?: string;
  placeholder?: string;
  location?: string;
  activeSearch?: boolean;
  inputWrapperClass?: string;
};

const SearchInput = ({ iconClick, isHeroSearch, inputClass, iconName, placeholder, location, autoFocus, page, ...props }: SearchInputProps) => {
  SegmentTrackingAction.search({ locationName: location }, TRACKING_TYPES.searchEngaged);
  // const QueryResults = (propAttrs: $FixMe) => (isHeroSearch ? <HeroPageResults page={page} {...propAttrs} /> : <Results {...propAttrs} />);
  const QueryResults = (propAttrs: $FixMe) => (isHeroSearch ? <HeroPageResults page={page} {...propAttrs} /> : <Results {...propAttrs} />);

  const autocompleteViewFn =
    context =>
    ({ autocompletedResults, getItemProps }) => {
      const scoredResults = getScoredResults({
        results: autocompletedResults,
      });
      const serviceResults = scoredResults.filter(r => !r.is_product || r.is_product.raw === 'false');
      const productResults = scoredResults.filter(r => r.is_product && r.is_product.raw === 'true');

      return (
        <QueryResults
          serviceResults={serviceResults}
          productResults={productResults}
          scoredResults={scoredResults}
          iconClick={iconClick}
          searchTerm={context.searchTerm}
          shouldTrackClickThrough
          getItemProps={getItemProps}
          {...props}
        />
      );
    };

  const inputViewDisplay = ({ getAutocomplete, getInputProps }) => {
    const searchboxStyles = isHeroSearch ? styles.homepageSearchbox : styles.searchBox;

    return (
      <div className={searchboxStyles}>
        <InputField
          key={isHeroSearch ? 'heroSearchInput' : 'navigationSearchInput'}
          iconName={iconName}
          iconClass={styles.closeIcon}
          iconOnClick={iconClick}
          dataTestId={isHeroSearch ? 'hero-search-input' : 'nav-search-input'}
          autoFocus={autoFocus}
          {...props}
          {...getInputProps({
            placeholder,
          })}
        />
        {getAutocomplete()}
      </div>
    );
  };

  const WithSearchDisplay = context => (
    <Layout
      header={
        <SearchBox
          autocompleteMinimumCharacters={2}
          autocompleteResults={{
            title: 'name',
            shouldTrackClickThrough: true,
          }}
          useAutocomplete
          isOpen
          allAutocompletedItemsCount
          autocompleteView={autocompleteViewFn(context)}
          inputView={inputViewDisplay}
        />
      }
    />
  );
  const searchInputDisplay = (
    <SearchProvider
      config={searchConfig({
        searchKey: process.env.NEXT_PUBLIC_SEARCH_KEY,
        engineName: process.env.NEXT_PUBLIC_SEARCH_ENGINE_NAME,
        endpointBase: process.env.NEXT_PUBLIC_SEARCH_ENDPOINT_BASE,
      })}
    >
      <WithSearch mapContextToProps={context => context}>{WithSearchDisplay}</WithSearch>
    </SearchProvider>
  );

  return <div className={cn(inputClass, styles.columnOverrides)}>{searchInputDisplay}</div>;
};

SearchInput.defaultProps = {
  placeholder: DEFAULT_TEXTS.PLACEHOLDER.heroSearchText,
  iconName: '',
};

export default memo(SearchInput);
